import { render, staticRenderFns } from "./IconTelephone.vue?vue&type=template&id=56fe2dae&"
import script from "./IconTelephone.vue?vue&type=script&lang=js&"
export * from "./IconTelephone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fe2dae')) {
      api.createRecord('56fe2dae', component.options)
    } else {
      api.reload('56fe2dae', component.options)
    }
    module.hot.accept("./IconTelephone.vue?vue&type=template&id=56fe2dae&", function () {
      api.rerender('56fe2dae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTelephone.vue"
export default component.exports